import React, { FC, useState } from 'react';
import LazyImage from '../lazy-image';
import styled from 'styled-components';
import { Grid, Paragraph } from '../UIKit/system';
import Title from '../title';
import IconButton from '../icon-button';
import { getFluidGatsbyImage } from '../../utils/gatsby-storyblok-image-fixed';
import VideoPlayerOverlay from '../video-player-overlay';

interface VideoLongCardProps {
  image: Record<string, any>;
  subtitle: string;
  title: string;
  duration: string | number;
  video: string;
}

export const VideoLongCard: FC<VideoLongCardProps> = (props) => {
  const { image, subtitle, title, duration, video } = props;
  const imageProps = getFluidGatsbyImage(image);
  const [open, setOpen] = useState(false);

  return (
    <StyledContainer>
      <StyledImageContainer>
        <LazyImage
          fluid={imageProps}
          style={{
            overflow: 'hidden'
          }}
        />
      </StyledImageContainer>
      <StyledInfo>
        <Paragraph color="grey" mb={10} fontSizeExtraSmall>
          {subtitle}
        </Paragraph>
        <StyledTitleArea>
          <Title as="h3" fontSizeExtraSmall>
            {title}
          </Title>
          <IconButton
            icon={{ name: 'playCircle' }}
            onClick={() => setOpen(true)}
          />
        </StyledTitleArea>
        <Paragraph color="grey" fontSizeExtraSmall>
          {duration} {Number(duration) > 1 ? 'mins' : 'min'}
        </Paragraph>
      </StyledInfo>
      {open && (
        <VideoPlayerOverlay
          videoLink={video}
          handlePopupClose={() => setOpen(false)}
        />
      )}
    </StyledContainer>
  );
};

const StyledContainer = styled(Grid).attrs(() => ({
  backgroundColor: 'lightGrey',
  gridTemplateColumns: [null, 'auto 1fr'],
  borderRadius: 'var(--Radius-Radius-3, 16px)'
}))``;

const StyledImageContainer = styled(Grid).attrs(() => ({
  width: ['100%', 320]
}))`
  border-radius: 16px 0px 0px 16px !important;
  overflow: hidden;
`;

const StyledInfo = styled(Grid).attrs(() => ({
  py: [20, 40],
  px: [28, 56]
}))``;

const StyledTitleArea = styled(Grid).attrs(() => ({
  gridAutoFlow: 'column',
  gridGap: 20,
  justifyContent: 'space-between'
}))``;
